import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wp1200 withPadding weatherAlerts"
}
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "flex gap-2 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-L" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "my-2"
}
const _hoisted_7 = {
  key: 1,
  class: "my-2"
}
const _hoisted_8 = {
  key: 0,
  class: "box surface-200 p-3 border-round-xl"
}
const _hoisted_9 = { class: "flex flex-column bg-white border-round-lg p-3 gap-3" }
const _hoisted_10 = { class: "flex flex-column gap-1" }
const _hoisted_11 = { class: "font-bold text-base" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_13 = { class: "checkbox flex flex-column gap-2 mt-3" }
const _hoisted_14 = { class: "flex justify-content-end align-items-center gap-4" }
const _hoisted_15 = {
  key: 1,
  class: "box flex flex-column bg-white border-round-md py-3 gap-3 sm:align-items-center"
}
const _hoisted_16 = { class: "flex flex-column sm:flex-row sm:justify-content-between sm:align-items-center w-full gap-3" }
const _hoisted_17 = { class: "flex gap-3 align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_bell_full text-primary border-2 border-circle border-dashed border-primary p-3 inline-block" })
], -1)
const _hoisted_19 = { class: "flex flex-column" }
const _hoisted_20 = { class: "ml-auto" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_edit" }, null, -1)
const _hoisted_22 = { class: "box surface-200 p-3 border-round-xl w-full" }
const _hoisted_23 = { class: "flex flex-column bg-white border-round-lg p-3 gap-3" }
const _hoisted_24 = { class: "flex flex-column gap-1 mb-2" }
const _hoisted_25 = { class: "mt-2" }
const _hoisted_26 = { class: "pl-4" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "text-sm mt-2" }
const _hoisted_31 = { class: "fillDialogTitle" }
const _hoisted_32 = { class: "fillDialogButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Weather' }))),
                class: "text-gray-900 border-none bg-transparent text-xl cursor-pointer"
              }, _hoisted_5),
              ((_ctx.showSettings || !_ctx.isNotificationsActive) && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.$t("weather.alerts.subscribe")), 1))
                : (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.$t("weather.alerts.subscribe_title")), 1))
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("weather.alerts.description")), 1)
          ]),
          ((_ctx.showSettings || !_ctx.isNotificationsActive) && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("weather.alerts.how")), 1),
                    (!_ctx.user.phone_number)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createTextVNode(_toDisplayString(_ctx.$t("my_waste.sms_disabled")) + " ", 1),
                          _createVNode(_component_router_link, { to: { name: 'MyProfile' } }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("user.my_profile")), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(". ")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full text-base", {
                'bg-primary': _ctx.selection.sms,
                'bg-gray-300': !_ctx.user.phone_number,
              }])
                      }, [
                        _createElementVNode("span", {
                          class: "h-full w-full cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
                  () => {
                    (_ctx.selection.sms = !_ctx.selection.sms), _ctx.changeSelection();
                  }
                , ["stop"]))
                        }, _toDisplayString(_ctx.$t("my_waste.private.channels.sms")), 1),
                        _createVNode(_component_Checkbox, {
                          disabled: !_ctx.user.phone_number,
                          modelValue: _ctx.selection.sms,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selection.sms) = $event)),
                          binary: true,
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSelection()))
                        }, null, 8, ["disabled", "modelValue"])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex gap-1 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full text-base", { 'bg-primary': _ctx.selection.push }])
                      }, [
                        _createElementVNode("span", {
                          class: "h-full w-full cursor-pointer",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
                  () => {
                    (_ctx.selection.push = !_ctx.selection.push), _ctx.changeSelection();
                  }
                , ["stop"]))
                        }, _toDisplayString(_ctx.$t("my_waste.private.channels.push")), 1),
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.selection.push,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selection.push) = $event)),
                          binary: true,
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeSelection()))
                        }, null, 8, ["modelValue"])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full text-base", { 'bg-primary': _ctx.selection.email }])
                      }, [
                        _createElementVNode("span", {
                          class: "h-full w-full cursor-pointer",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(
                  () => {
                    (_ctx.selection.email = !_ctx.selection.email), _ctx.changeSelection();
                  }
                , ["stop"]))
                        }, _toDisplayString(_ctx.$t("my_waste.private.channels.email")), 1),
                        _createVNode(_component_Checkbox, {
                          name: "email",
                          modelValue: _ctx.selection.email,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selection.email) = $event)),
                          binary: true,
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeSelection()))
                        }, null, 8, ["modelValue"])
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "border-none text-primary bg-transparent cursor-pointer",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelSettings && _ctx.cancelSettings(...args)))
                    }, _toDisplayString(_ctx.$t("global.cancel")), 1),
                    _createElementVNode("button", {
                      class: "flex gap-2 bg-primary border-none py-2 px-3 border-round-3xl shadow-2 cursor-pointer",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveSubscription && _ctx.saveSubscription(...args)))
                    }, _toDisplayString(_ctx.$t("waste_notification.save")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.showSettings && _ctx.isNotificationsActive && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("weather.alerts.active")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "flex align-items-center gap-2 border-none bg-transparent text-600 cursor-pointer",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showSettings = true))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.private.edit")), 1),
                      _hoisted_21
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("weather.alerts.channels")), 1),
                      _createElementVNode("div", _hoisted_26, [
                        (_ctx.subscription.sms)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_27, _toDisplayString(_ctx.$t("weather.alerts.sms")), 1))
                          : _createCommentVNode("", true),
                        (_ctx.subscription.email)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_28, _toDisplayString(_ctx.$t("weather.alerts.email")), 1))
                          : _createCommentVNode("", true),
                        (_ctx.subscription.push)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_29, _toDisplayString(_ctx.$t("weather.alerts.push")), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("weather.alerts.disclaimer")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.showUnsubscribeDialog,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showUnsubscribeDialog) = $event)),
      class: "successDialog",
      tabindex: "1",
      closable: false,
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("weather.alerts.unsubscribe")), 1),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            tabindex: "1",
            class: "defaultButton",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveSubscription && _ctx.saveSubscription(...args)))
          }, _toDisplayString(_ctx.$t("weather.alerts.unsubscribe_confirm")), 1),
          _createElementVNode("span", {
            tabindex: "1",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showUnsubscribeDialog = false)),
            onKeypress: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.showUnsubscribeDialog = false), ["enter"]))
          }, _toDisplayString(_ctx.$t("global.cancel")), 33)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}